export const GAMES_SUGGESTIONS = {
  gameCellWidth: 156,
  gameCellOffset: 48,

  ACTION_TYPES: {
    feedByABTesting: 'feedByABTesting',
    onScroll: 'onScroll',
    onDisplayEvent: 'onDisplayEvent',
    onScrollEvent: 'onScrollEvent',
    onGameClickEvent: 'onGameClickEvent',
  },

  FEED_BY: {
    popular: 1,
    related: 2
  },

  CONTEXTS: {
    game: 'game',
    competition: 'competition'
  }
}
